export default "__VITE_ASSET__B76pa5vN__"